import { Map } from 'immutable'
import { imageSizes } from './imageSizes'

export const getImageUrls = (fullImageUrl: string) => {
  const images = Map(
    imageSizes.map((size) => {
      if (!fullImageUrl) return [size, fullImageUrl]
      if (size === 'full') return [size, fullImageUrl]
      const cleanSize = size.includes("original") ? size.split("_")[0] : size
      const splitUrl = fullImageUrl.split('/')
      const fileName = splitUrl[splitUrl.length - 1]
      const newFileName = fileName.replace('.', '_' + size + '.')
      const containerName = splitUrl[splitUrl.length - 2]
      const newContainerName = containerName + '-' + cleanSize
      const blobstorageUrl = splitUrl.splice(0, splitUrl.length - 2).join('/')
      let newUrl = blobstorageUrl + '/' + newContainerName + '/' + newFileName

      const splitNewUrl = newUrl.split(".")
      // Default to the webp version of the image (when available)
      if (!splitNewUrl[splitNewUrl.length - 2].endsWith("_original") && !newUrl.endsWith("webp")) {
        const splitUrl = newUrl.split(".")
        splitUrl[splitUrl.length - 1] = "webp"
        newUrl = splitUrl.join(".")
      }
      return [size, encodeURI(newUrl)]
    })
  )
  return images;
}
